import {
  productsDetectMetadataManifest,
  type ProductsDetectMetadataProgressPhase,
} from '@foodlista/operations'
import { PRODUCTS_CACHE_KEYS } from '~/domains/products/queries'
import { registerOperationCompletionEffect } from '../completion/registry'
import { presentProductsDetectMetadata } from '../presentation/presenters'
import { registerOperationPresenter } from '../presentation/registry'
import { registerOperationProgressTranslator } from '../progress/registry'

registerOperationProgressTranslator(
  productsDetectMetadataManifest.type,
  (phase, t) => {
    const typed = phase as ProductsDetectMetadataProgressPhase
    switch (typed.kind) {
      case 'analyzing':
        return t(
          'operations.boc.progress.productsDetectMetadata.analyzing',
          { count: typed.count },
          typed.count,
        )
      case 'detected':
        return t(
          'operations.boc.progress.productsDetectMetadata.detected',
          { count: typed.count },
          typed.count,
        )
      case 'fallback':
        return t('operations.boc.progress.productsDetectMetadata.fallback')
      case 'done':
        return t('operations.boc.progress.productsDetectMetadata.done')
    }
  },
)

registerOperationPresenter(
  productsDetectMetadataManifest.type,
  presentProductsDetectMetadata,
)

registerOperationCompletionEffect(
  productsDetectMetadataManifest.type,
  async ({ restaurantSlug, queryClient }) => {
    await queryClient.invalidateQueries({
      queryKey: PRODUCTS_CACHE_KEYS.bySearch.all(restaurantSlug),
    })
  },
)
